import dataSelect from "@store/dataForSelect/reducers";

import { level_select } from "@Modules/Question/configs/constants";

export default dataSelect(level_select);
